/**
 * 새 배포 감지 — 웹은 nginx 정적 서빙이라 index.html(no-cache)이 가리키는 해시 자산 이름이 배포마다 바뀐다.
 * 열어 둔 화면이 1분마다(+화면 복귀 시) index.html 을 다시 받아 지금 실행 중인 스크립트와 다르면 배너를 띄운다.
 * (예전엔 Go 서버 /v1/config 의 config_hash 를 봤다)
 */

const intervalMillis = 60000;
const scriptRe = /<script[^>]+type="module"[^>]+src="([^"]+)"/;

const currentScript = () => document.querySelector<HTMLScriptElement>('script[type="module"][src]')?.getAttribute("src") ?? null;

class VersionChecker {
  timer: ReturnType<typeof setInterval> | null = null;

  listener: (() => void) | null = null;

  initial: string | null = null;

  onVisible = () => {
    if (document.visibilityState === "visible") {
      this.check();
    }
  };

  startWorker() {
    if (this.timer !== null || import.meta.env.DEV) {
      return;
    }
    this.initial = currentScript();
    this.timer = setInterval(() => this.check(), intervalMillis);
    document.addEventListener("visibilitychange", this.onVisible);
  }

  stopWorker() {
    if (this.timer !== null) {
      clearInterval(this.timer);
      this.timer = null;
    }
    document.removeEventListener("visibilitychange", this.onVisible);
  }

  registerListener(listener: () => void) {
    this.listener = listener;
  }

  resetListener() {
    this.listener = null;
  }

  async check() {
    if (!this.initial) {
      return;
    }
    try {
      const response = await fetch("/index.html", { cache: "no-store" });
      const latest = (await response.text()).match(scriptRe)?.[1];
      if (latest && latest !== this.initial) {
        console.log(`[VersionChecker] New version available: ${latest}`);
        this.listener?.();
      }
    } catch (e) {
      console.log(`[VersionChecker] Error checking version`, e);
    }
  }
}

const versionChecker = new VersionChecker();
export default versionChecker;
